<template>
  <div class="code-join-team-container">
    <div class="code-join-team-box">
      <el-form
        ref="teamJoinForm"
        v-loading="saveLoading"
        :model="teamJoinForm"
        :rules="teamJoinRules"
        class="code-join-team-form"
        label-width="120px"
      >
        <el-form-item
          :label="$t('views.user_center.invitation_code')"
          prop="inviteCode"
        >
          <el-input
            v-model="teamJoinForm.inviteCode"
            :placeholder="$t('views.user_center.enter_invitation_code')"
          />
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
import { getTeamInfoByInviteCode, joinTeam } from '@/api/team'

export default {
  name: 'CodeJoinTeam',
  components: {},
  props: {
    isDialog: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      teamJoinForm: {
        inviteCode: ''
      },
      teamJoinRules: {
        inviteCode: [
          { required: true, message: this.$t('views.user_center.enter_invitation_code'), trigger: 'blur' }
        ]
      },
      saveLoading: false,
      teamInfo: {}
    }
  },
  mounted() {
  },
  methods: {
    joinTeam() {
      this.$refs['teamJoinForm'].validate((valid) => {
        if (valid) {
          const params = {}
          if (this.saveLoading) {
            return false
          }
          this.saveLoading = true
          params.invite_code = this.teamJoinForm.inviteCode
          this.getTeamInfo().then(res => {
            if (res) {
              joinTeam(params).then((response) => {
                this.saveLoading = false
                if (response && response.code === 0) {
                  const applyStatus = Number(response.data && response.data.apply_status)
                  if (this.isDialog) {
                    if (applyStatus !== 1) {
                      this.$message.success(this.$t('views.user_center.join_team_applied'))
                      this.$emit('close-dlg')
                    } else {
                      this.$message.success(this.$t('views.user_center.join_team_success'))
                      this.$emit('update-team', response.data && response.data.team_id)
                    }
                  }
                }
              }).catch(() => {
                this.saveLoading = false
              })
            }
          }).catch(e => {

          })
        } else {
          return false
        }
      })
    },
    async getTeamInfo() {
      return new Promise((resolve, reject) => {
        getTeamInfoByInviteCode({ invite_code: this.teamJoinForm.inviteCode }).then((response) => {
          if (response && response.code === 0) {
            this.teamInfo = response.data
          }
          resolve(true)
        }).catch(() => {
          resolve(false)
        })
      })
    },
    initJoinTeam() {
      this.teamJoinForm.inviteCode = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/views/user_center/components/code_join_team";
</style>
